"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ASN_DIMENSIONS = void 0;
const ASN_DIMENSIONS = exports.ASN_DIMENSIONS = ['src_as', 'src_asn_generic', 'src_nexthop_asn', 'src_second_asn', 'src_third_asn', 'src_secondhop_asn_noprepend', 'src_thirdhop_asn_noprepend', 'dst_as', 'dst_asn_generic', 'dst_nexthop_asn', 'dst_second_asn', 'dst_third_asn', 'dst_secondhop_asn_noprepend', 'dst_thirdhop_asn_noprepend'];